export default __webpack_public_path__ + "static/media/icon-users-active.c1735c4f.svg";